<template>
  <el-dialog :title="$t('addBasePrivilege.addPrivilege')" :visible.sync="dialogVisible" width="70%"
    @close="closeDialog">
    <el-form :model="addBasePrivilegeInfo" :rules="rules" ref="form" label-width="120px">
      <el-form-item :label="$t('addBasePrivilege.privilegeName')" prop="name">
        <el-input v-model="addBasePrivilegeInfo.name" :placeholder="$t('addBasePrivilege.inputPrivilegeName')"
          clearable>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('addBasePrivilege.resourcePath')" prop="resource">
        <el-input v-model="addBasePrivilegeInfo.resource" :placeholder="$t('addBasePrivilege.inputResourcePath')"
          clearable>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('addBasePrivilege.merchantType')" prop="domain">
        <el-select v-model="addBasePrivilegeInfo.domain" :placeholder="$t('addBasePrivilege.selectMerchantType')"
          style="width:100%">
          <el-option v-for="item in merchantTypes" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('addBasePrivilege.description')">
        <el-input type="textarea" v-model="addBasePrivilegeInfo.description"
          :placeholder="$t('addBasePrivilege.inputDescription')" :rows="3">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveBasePrivilegeInfo">{{ $t('common.save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveBasePrivilege } from '@/api/dev/basePrivilegeApi'

export default {
  name: 'AddBasePrivilege',
  data() {
    return {
      dialogVisible: false,
      addBasePrivilegeInfo: {
        pId: '',
        name: '',
        resource: '',
        domain: '',
        description: '',
        mId: ''
      },
      merchantTypes: [
        { value: '800900000001', label: this.$t('addBasePrivilege.operationTeam') },
        { value: '800900000005', label: this.$t('addBasePrivilege.merchant') },
        { value: '800900000000', label: this.$t('addBasePrivilege.devTeam') }
      ],
      rules: {
        name: [
          { required: true, message: this.$t('addBasePrivilege.privilegeNameRequired'), trigger: 'blur' },
          { min: 2, max: 10, message: this.$t('addBasePrivilege.privilegeNameLength'), trigger: 'blur' }
        ],
        resource: [
          { required: true, message: this.$t('addBasePrivilege.resourcePathRequired'), trigger: 'blur' },
          { min: 1, max: 200, message: this.$t('addBasePrivilege.resourcePathLength'), trigger: 'blur' }
        ],
        domain: [
          { required: true, message: this.$t('addBasePrivilege.merchantTypeRequired'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    open(params) {
      this.addBasePrivilegeInfo.mId = params.mId
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
      this.addBasePrivilegeInfo = {
        pId: '',
        name: '',
        resource: '',
        domain: '',
        description: '',
        mId: ''
      }
    },
    saveBasePrivilegeInfo() {
      this.$refs.form.validate(valid => {
        if (!valid) return

        saveBasePrivilege(this.addBasePrivilegeInfo)
          .then(() => {
            this.$message.success(this.$t('addBasePrivilege.saveSuccess'))
            this.closeDialog()
            this.$emit('success')
          })
          .catch(error => {
            console.error('保存失败:', error)
            this.$message.error(this.$t('addBasePrivilege.saveFailed'))
          })
      })
    }
  }
}
</script>